/** Unified UI tokens — single source for spacing, icons, sidebar, typography */

export const ICON = {
  xs: 14,
  sm: 16,
  md: 18,
  lg: 20,
};

export const SIDEBAR = {
  expanded: 272,
  collapsed: 72,
  header: 64,
  mobile: 280,
};

export const LAYOUT = {
  headerH: "h-16",
  /** No extra left pad on lg+ — grid layout sits content flush beside sidebar */
  mainPad: "p-4 sm:p-6 lg:py-7 lg:pr-7 lg:pl-5",
  headerPad: "px-4 sm:px-6 lg:pr-7 lg:pl-5",
};

/** Tailwind class fragments */
export const UI = {
  fontBody:    "font-sans antialiased",
  fontLabel:   "text-[11px] font-semibold uppercase tracking-[0.1em]",
  fontNav:     "text-[13px] font-medium leading-none tracking-tight",
  fontNavGroup:"text-[10px] font-bold uppercase tracking-[0.12em]",

  iconBtn:     "flex h-9 w-9 shrink-0 items-center justify-center rounded-xl text-[#8A9778] transition-colors hover:bg-[#F8F5F0] hover:text-[#D4A45A] dark:text-[#A8B29A] dark:hover:bg-white/5 dark:hover:text-[#D4A45A]",
  iconBtnSm:   "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-[#8A9778] transition-colors hover:bg-[#F8F5F0] hover:text-[#D4A45A] dark:text-[#A8B29A] dark:hover:bg-white/5 dark:hover:text-[#D4A45A]",

  avatar:      "flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#8A9778] to-[#6B7760] text-[11px] font-bold text-white shadow-md shadow-[#8A9778]/15",
  avatarSm:    "flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#8A9778] to-[#6B7760] text-[11px] font-bold text-white shadow-sm",

  inputSearch: "h-9 w-full max-w-[18rem] rounded-xl border border-slate-200/80 bg-[#F8F5F0]/60 pl-9 pr-10 text-sm text-slate-700 outline-none transition-all placeholder:text-slate-400 focus:border-[#8A9778] focus:bg-white focus:ring-4 focus:ring-[#8A9778]/10 dark:border-white/10 dark:bg-white/5 dark:text-slate-300 dark:placeholder:text-slate-600 dark:focus:bg-white/10 xl:max-w-[20rem]",

  badgeRole:   "inline-flex rounded-full bg-[#8A9778]/12 px-2 py-0.5 text-[10px] font-semibold text-[#6B7760] capitalize dark:bg-[#8A9778]/20 dark:text-[#A8B29A]",
  badgeGold:   "inline-flex rounded-full bg-[#D4A45A]/15 px-2 py-0.5 text-[10px] font-semibold text-[#B8893F] dark:text-[#D4A45A]",

  dropdown:    "absolute right-0 top-full mt-2 z-50 w-52 overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-xl shadow-slate-900/8 dark:border-white/10 dark:bg-[#252820] dark:shadow-black/30",
  dropdownItem:"flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm text-slate-600 no-underline transition hover:bg-[#F8F5F0] hover:text-[#6B7760] dark:text-slate-400 dark:hover:bg-white/5 dark:hover:text-slate-200",

  navIcon: (active) =>
    active
      ? "text-[#D4A45A] dark:text-[#E8C48A]"
      : "text-[#8A9778]/75 dark:text-[#A8B29A]/75 group-hover:text-[#D4A45A] dark:group-hover:text-[#D4A45A]",

  navLink: (active, collapsed) => {
    const base = "sidebar-link group relative flex items-center gap-3 font-medium transition-all duration-200";
    const size = collapsed
      ? "h-10 w-10 justify-center mx-auto rounded-xl"
      : "w-full rounded-xl px-3 py-2.5 text-[13px]";
    const state = active
      ? "sidebar-nav-active"
      : "text-slate-600 hover:bg-[#F8F5F0]/80 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-white/[0.04] dark:hover:text-slate-200";
    return `${base} ${size} ${state}`;
  },
};

/** @deprecated Layout uses CSS grid — kept for any legacy usage */
export function sidebarPadding(collapsed) {
  return collapsed ? "lg:pl-[72px]" : "lg:pl-[272px]";
}

export function dashGridCols(collapsed) {
  return collapsed ? `${SIDEBAR.collapsed}px 1fr` : `${SIDEBAR.expanded}px 1fr`;
}

export function userInitials(name, fallback = "U") {
  if (!name) return fallback;
  return name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();
}
